import {Dropdown, DropdownItem, PresentationPaneHeader, RadioGroup} from "../../components";
import {DropdownGroup, MenuDivider} from "xps-react";
import {NO_OP} from "../../constants/common";
import React, { useEffect, useState } from "react";
import {useParams} from "react-router-dom";
import useProfileAndProposals from "../../hooks/useProfileAndProposals";
import {RouteWithId} from "../../routes/types";
import classNames from "classnames";
import { DataDisplayView, FundingDisplayOptions } from "./models/Funding";
import {useAnalyticsTrackers} from "../../utils/useAnalyticsTrackers";

const FundingHeader = (props: {
    handleChangeDisplayView: (e: React.ChangeEvent<HTMLInputElement>) => void,
    displayView: DataDisplayView,
    isFundingLoadedFirstTime: boolean,
    setDisplayOptions: (displayOptions: FundingDisplayOptions) => void
}) => {
    const [showFundedByInflows, setShowFundedByInflows] = useState<boolean>(false);
    const [showFundedByNonInvestable, setShowFundedByNonInvestable] = useState<boolean>(false);
    const {id} = useParams<RouteWithId>();
    const displayName = useProfileAndProposals(id).approvedProfile.displayName;
    const {page} = useAnalyticsTrackers("enableGoogleAnalyticsInGFOT")

    useEffect(() => {
        let updatedDisplayOptions = FundingDisplayOptions.ONLY_PORTFOLIO;
        if (showFundedByInflows && !showFundedByNonInvestable) {
            updatedDisplayOptions = FundingDisplayOptions.PORTFOLIO_AND_INFLOWS
        } else if (!showFundedByInflows && showFundedByNonInvestable) {
            updatedDisplayOptions = FundingDisplayOptions.PORTFOLIO_AND_NON_INVESTABLE
        } else if (showFundedByInflows && showFundedByNonInvestable) {
            updatedDisplayOptions = FundingDisplayOptions.PORTFOLIO_AND_INFLOWS_AND_NON_INVESTABLE
        }
        props.setDisplayOptions(updatedDisplayOptions);
    }, [showFundedByInflows, showFundedByNonInvestable]);

    const toggleFundedByInflows = () => {
        setShowFundedByInflows(!showFundedByInflows);
        if (!showFundedByInflows) {
            page("GoalsFunding_ShowFundedByInflows_Checked");
        }
    }

    const toggleFundedByNonInvestable = () => {
        setShowFundedByNonInvestable(!showFundedByNonInvestable);

        if (!showFundedByNonInvestable) {
            page("GoalsFunding_ShowFundedByNonInvestable_Checked");
        }
    }

    const titleRowChildren = () => {
        return (
            <span className={classNames('page-action-menu', 'menu_down')}>
                <Dropdown
                    alignRight
                    buttonIcon="right"
                    buttonKind="secondary"
                    buttonSize="medium"
                    inverse={true}
                    className="funding-page-action-menu__dropdown"
                    drop="drop"
                    dropdownKind="menu"
                    rounded={true}
                    iconNameOpen="menu_down"
                    iconNameClose="menu_up"
                    panelHeight='auto'
                    panelWidth={240}
                    aria-label='show-display-options'
                    defaultText='Display Options'
                    value=''
                >
                    <DropdownGroup groupName={` `} key={`ls-dropdown-group`} show={true}>
                    <DropdownItem className="funding-page-action-menu-options" value="do_not_use" itemText=""
                                  onClick={NO_OP}>
                            <RadioGroup
                                id="dataDisplay"
                                name="dataDisplay"
                                label="Data Table"
                                layout="vertical"
                                values={[DataDisplayView.DOLLAR_VIEW, DataDisplayView.PERCENTAGE_VIEW]}
                                onChange={props.handleChangeDisplayView}
                                selected={props.displayView}
                            />
                        </DropdownItem>
                        <MenuDivider
                            className="funding-menu-divider"
                            role="separator"
                            itemText=""
                            value="do-not-use"
                        />
                        <DropdownItem
                            key="showFundedByInflows"
                            onClick={NO_OP}
                        >
                            <div
                                className="funding-page-action-menu__dropdown funding-page-action-menu__dropdown-item-flex">
                              <input type="checkbox" id="funded-by-inflows-input"
                                     data-testid="funded-by-inflows-input"
                                     checked={showFundedByInflows}
                                     onChange={toggleFundedByInflows}/>
                              <label htmlFor="option1">Show Funded By Inflows</label>
                            </div>
                        </DropdownItem>
                        <DropdownItem
                            key="showFundedByNonInvestable"
                            onClick={NO_OP}
                        >
                            <div data-testid="funded-by-non-investable-div"
                                className="funding-page-action-menu__dropdown funding-page-action-menu__dropdown-item-flex">
                              <input type="checkbox" data-testid="funded-by-non-investable-input"
                                     checked={showFundedByNonInvestable}
                                     onChange={toggleFundedByNonInvestable}/>
                              <label htmlFor="option1">Show Funded by Non Investable</label>
                            </div>
                        </DropdownItem>
                    </DropdownGroup>
                </Dropdown>
            </span>
        );
    }

    return (
        <PresentationPaneHeader className={`goals-funding__header`}
                                displayName={displayName}
                                title={'Goal Funding Over Time'}
                                titleRow={titleRowChildren()}
        />
    )
}

export default FundingHeader;